import React, { useState } from "react";
import "./BuiltforYou.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";

import CommonHeading from "../../common-component/common-heading/CommonHeading";

const speakers = [
 {
    name: "Jasmit Koch",
    role: "CEO",
    image: "/assets/images/global-perspective/alan-roper.webp"
    
    
  },
  {
    name: "Karan Singh",
    role: "Chairman",
    image: "/assets/images/global-perspective/anshu-sharma"
    
  },
  {
    name: "Anant Goenka",
    role: "Vice Chairman",
    image: "/assets/images/global-perspective/jeans-meyar"
    
  },
  {
    name: "Avani Davda",
    role: "Strategic Advisor",
    image: "/assets/images/global-perspective/nitin-pangarkar.webp"

  },
   {
    name: "Jasmit Koch",
    role: "CEO",
    image: "/assets/images/global-perspective/alan-roper.webp"

  },
  {
    name: "Karan Singh",
    role: "Chairman",
    image: "/assets/images/global-perspective/anshu-sharma"

  },
  {
    name: "Anant Goenka",
    role: "Vice Chairman",
    image: "/assets/images/global-perspective/jeans-meyar"
   
  },
  {
    name: "Avani Davda",
    role: "Strategic Advisor",
    image: "/assets/images/global-perspective/nitin-pangarkar.webp"

  },
   {
    name: "Jasmit Koch",
    role: "CEO",
    image: "/assets/images/global-perspective/alan-roper.webp"
    
  },
  {
    name: "Karan Singh",
    role: "Chairman",
    image: "/assets/images/global-perspective/anshu-sharma"
    
  },
  {
    name: "Anant Goenka",
    role: "Vice Chairman",
    image: "/assets/images/global-perspective/jeans-meyar"
 
  },
  {
    name: "Avani Davda",
    role: "Strategic Advisor",
    image: "/assets/images/global-perspective/nitin-pangarkar.webp"
  
  },
];

const BuiltforYou = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="builtforyou_section">
      <div className="container">
        <CommonHeading
          subTitle="Global Faculty."
          title="Global Perspective."
          description="Learn from internationally acclaimed academicians who connect global business thinking with practical AI leadership."
        />
      </div>

      <div className="swiper_wrapper">
        <div
          className="slider_bg"
          style={{
            backgroundImage: `url(${speakers[activeIndex].image})`,
          }}
        />

        <Swiper
          modules={[Autoplay]}
          className="speakerSwiper"
          loop={true}
          centeredSlides={true}
          slidesPerView={5}
          spaceBetween={30}
          speed={700}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          onSlideChange={(swiper) => {
            setActiveIndex(swiper.realIndex);
          }}
          breakpoints={{
            320: {
              slidesPerView: 1.3,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 30,
            },
          }}
        >
          {speakers.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="speaker_card">
                <img src={item.image} alt={item.name} />
                <div className="speaker_overlay"></div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default BuiltforYou;